import { render } from "./pay-order.vue?vue&type=template&id=47cfcef0&scoped=true"
import script from "./pay-order.vue?vue&type=script&lang=js"
export * from "./pay-order.vue?vue&type=script&lang=js"

import "./pay-order.vue?vue&type=style&index=0&id=47cfcef0&scoped=true&lang=scss"

import exportComponent from "F:\\my-work\\company\\yuanxi\\yuanxi-csspw\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47cfcef0"]])

export default __exports__